import React, { useEffect, useState } from 'react';
import { Spinner } from '../../../SpinnerComponent/Spinner';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { GetUserUpdateHistoryDetails } from '../../../../Services/userServices';
import { showError } from '../../../../Helper';
import TableContainer from '@material-ui/core/TableContainer';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { Collapse, IconButton, ButtonBase } from '@material-ui/core';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import { PaginationComponent } from '../../../PaginationComponent/PaginationComponent';

export default function UserHistoryComponent({
  parentTranslationPath,
  activeItem: userId,
}) {
  const { t: translate } = useTranslation(parentTranslationPath);
  const [filter, setFilter] = useState({
    pageIndex: 0,
    pageSize: parseInt(localStorage.getItem('Pagination')) || 25,
  });
  const [isLoading, setIsLoading] = useState(false);
  const [historyData, setHistoryData] = useState([]);
  const [expandedRow, setExpandedRow] = useState(null);
  const [differences, setDifferences] = useState({});

  const onExpandClicked = (item) => {
    if (item.actionType.toLowerCase() !== 'read') {
      const newExpandedRow =
        item.userUpdateHistoryId === expandedRow
          ? null
          : item.userUpdateHistoryId;
      setExpandedRow(newExpandedRow);

      if (newExpandedRow) {
        const newDifferences = processUserHistory(item);

        setDifferences((prev) => ({
          ...prev,
          [item.userUpdateHistoryId]: newDifferences,
        }));
      }
    }
  };

  const getUserUpdateHistoryDetails = async () => {
    const body = {
      userId,
      filter,
    };
    try {
      setIsLoading(true);
      const res = await GetUserUpdateHistoryDetails(body);
      setHistoryData(res);
    } catch (error) {
      showError(error);
    } finally {
      setIsLoading(false);
    }
  };

  const headerData = [
    { id: 1, title: 'date-and-time-viewed', align: 'left' },
    { id: 2, title: 'user', align: 'center' },
    { id: 3, title: 'type', align: 'right' },
  ];

  const changeHeaderData = [
    { id: 1, title: 'field-name', align: 'left' },
    { id: 2, title: 'changed-from', align: 'center' },
    { id: 3, title: 'changed-to', align: 'center' },
  ];
  const getReadableList = (arr) => {
    arr = arr || [];
    let key;
    if (typeof arr[0] === 'object') {
      const keys = Object.keys(arr[0]);
      key = keys.find((k) => k.toLowerCase().includes('name'));
    }
    return (
      arr
        .map((item) => (key ? item[key] : item))
        .filter(Boolean)
        .join(', ') || 'N/A'
    );
  };

  const processUserHistory = (item) => {
    const differences = [];

    const parseJson = (json) => {
      const parsed = JSON.parse(json);
      return parsed && typeof parsed === 'object' ? parsed : {};
    };

    const obj1 = parseJson(item?.response);

    const obj2 = parseJson(item?.responseAfterChanged);

    if (
      item.userUpdateCategory === 'UserData' ||
      item.userUpdateCategory === '0'
    ) {
      const simpleFields = [
        'firstName',
        'aboutMe',
        'branch',
        'carAvailability',
        'currentCompany',
        'dateOfBirth',
        'dateOfJoining',
        'department',
        'designationOnCurrentCompany',
        'drivingLicenseAvailability',
        'education',
        'email',
        'enableDNCRCallAccess',
        'extensionNumber',
        'fullName',
        'hasBrokerLicenseRegisterationNumber',
        'isDefaultBranchUser',
        'jobTitle',
        'lastName',
        'mainNumber',
        'mobileOperatingSystemName',
        'nationalityName',
        'numberOfTrainingsAttend',
        'phoneNumber',
        'registrationNo',
        'reportsTo',
        'reraExpiryDate',
        'secondName',
        'staffCode',
        'station',
        'targetMax',
        'targetMin',
        'totalYearsOfExperience',
        'totalYearsofExperienceInPSI',
        'userName',
        'userStatus',
        'whatsAppNumber',
      ];

      simpleFields.forEach((key) => {
        const val1 = obj1[key];

        const val2 = obj2[key];

        const areBothNullOrEmpty =
          (val1 === null || val1 === '') && (val2 === null || val2 === '');

        if (!areBothNullOrEmpty && val1 !== val2) {
          differences.push({
            field: key,
            oldValue: val1 || 'N/A',
            newValue: val2 || 'N/A',
          });
        }
      });

      const arrayFields = [
        'languages',
        'telephoneNumbers',
        'unitSaleTypes',
        'userAreaOfFocusCites',
        'userAreaOfFocusCommunities',
        'userAreaOfFocusCountries',
        'userAreaOfFocusDistricts',
        'userAreaOfFocusSubCommunities',
        'userDevelopers',
        'userDigitalCards',
        'userOperationTypes',
        'userProperties',
        'userTypes',
        'whatsAppNumbers',
      ];

      arrayFields.forEach((field) => {
        const beforeList = getReadableList(obj1[field] || []);
        const afterList = getReadableList(obj2[field] || []);

        if (beforeList !== afterList) {
          differences.push({
            field,
            oldValue: beforeList,
            newValue: afterList,
          });
        }
      });
    } else {
      const field = item.userUpdateCategory;
      if (JSON.stringify(obj1) !== JSON.stringify(obj2)) {
        if (Array.isArray(obj1)) {
          differences.push({
            field,
            oldValue: obj1.map((ele) => ele.RolesName) || 'N/A',
            newValue: obj2.map((ele) => ele.RolesName) || 'N/A',
          });
        } else {
          differences.push({
            field,
            oldValue: obj1?.PolicyName || 'N/A',
            newValue: obj2?.PolicyName || 'N/A',
          });
        }
      }
    }

    return differences;
  };

  const onPageIndexChanged = (pageIndex) => {
    setFilter((prev) => ({ ...prev, pageIndex }));
  };

  const onPageSizeChanged = (pageSize) => {
    setFilter((prev) => ({ ...prev, pageSize, pageIndex: 0 }));
  };
  useEffect(() => {
    if (userId) getUserUpdateHistoryDetails();
  }, [userId, filter]);

  const MAX_LENGTH = 35;

  const isTimeOrDateField = (field) =>
    field?.toLowerCase().includes('time') ||
    field?.toLowerCase().includes('date');

  const FormatValueWithViewMore = ({ value, isTimeOrDate }) => {
    const [expanded, setExpanded] = useState(false);

    if (isTimeOrDate) {
      return moment(value).isValid()
        ? moment(value).format('YYYY/MM/DD')
        : 'N/A';
    }

    const stringValue = String(value);
    if (stringValue.toLowerCase() === 'true') return 'On';
    if (stringValue.toLowerCase() === 'false') return 'Off';

    const renderCapsules = (text) => {
      return text.split(',').map((part, index) => (
        <span
          key={index}
          className='table-capsule mr-1 fw-simi-bold'
        >
          <span>{part.trim()}</span>
        </span>
      ));
    };
    if (stringValue.length > MAX_LENGTH && !expanded) {
      return (
        <>
          {renderCapsules(stringValue.substring(0, MAX_LENGTH))}
          <span>...</span>
          <ButtonBase
            onClick={(e) => {
              e.stopPropagation();
              setExpanded(true);
            }}
          >
            View More
          </ButtonBase>
        </>
      );
    }

    return <>{renderCapsules(stringValue || 'N/A')}</>;
  };

  return (
    <div className='p-relative w-100 m-2'>
      <Spinner
        isAbsolute
        isActive={isLoading}
      />
      <TableContainer className='user-history-header-table-custom'>
        <Table className='user-history-component-table-wrapper'>
          <TableHead className='p-2'>
            <TableRow>
              {headerData.map((item) => (
                <TableCell
                  align={item.align}
                  key={item.id}
                  className='header-table-cell'
                >
                  {translate(item.title)}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {historyData?.result?.map((item, index) => (
              <>
                <TableRow
                  key={index}
                  className={`user-history-component-row ${
                    index % 2 === 0 ? 'odd-row' : 'even-row'
                  }`}
                  onClick={() => onExpandClicked(item)}
                >
                  <TableCell
                    className='table-body-cell'
                    align='left'
                  >
                    <IconButton
                      aria-label='expand row'
                      size='small'
                      disabled={item.actionType.toLowerCase() === 'read'}
                      onClick={(e) => {
                        e.stopPropagation();
                        if (item.actionType.toLowerCase() !== 'read')
                          onExpandClicked(item);
                      }}
                    >
                      {expandedRow === item?.userUpdateHistoryId ? (
                        <KeyboardArrowUpIcon />
                      ) : (
                        <KeyboardArrowDownIcon />
                      )}
                    </IconButton>
                    {moment(item.actionDate).format('DD/MM/YYYY - hh:mm A') ||
                      'N/A'}
                  </TableCell>
                  <TableCell
                    className='table-body-cell'
                    align='center'
                  >
                    {item?.actionByName || 'N/A'}
                  </TableCell>
                  <TableCell
                    className='table-body-cell pr-2'
                    align='right'
                  >
                    {translate(item.actionType)}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell
                    style={{ paddingBottom: 0, paddingTop: 0 }}
                    colSpan={6}
                  >
                    <Collapse
                      in={expandedRow === item?.userUpdateHistoryId}
                      timeout='auto'
                      unmountOnExit
                    >
                      <TableContainer
                        margin={1}
                        className='user-history-header-table-custom user-history-inner-table'
                      >
                        <Table
                          size='small'
                          aria-label='purchases'
                        >
                          <TableHead>
                            <TableRow>
                              {changeHeaderData.map((header) => (
                                <TableCell
                                  align={header.align}
                                  key={header.id}
                                  className='header-table-cell'
                                >
                                  {translate(header.title)}
                                </TableCell>
                              ))}
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {differences[item.userUpdateHistoryId]?.map(
                              (diff, index) => (
                                <TableRow
                                  key={index}
                                  className={`user-history-component-row ${
                                    index % 2 === 0 ? 'odd-row' : 'even-row'
                                  }`}
                                >
                                  <TableCell align='left'>
                                    {translate(diff.field)}
                                  </TableCell>
                                  <TableCell align='center'>
                                    <div className='capsulesContainer'>
                                      <FormatValueWithViewMore
                                        value={diff?.oldValue}
                                        isTimeOrDate={isTimeOrDateField(
                                          diff.field
                                        )}
                                      />
                                    </div>
                                  </TableCell>
                                  <TableCell align='right'>
                                    <div className='capsulesContainer'>
                                      <FormatValueWithViewMore
                                        value={diff?.newValue}
                                        isTimeOrDate={isTimeOrDateField(
                                          diff.field
                                        )}
                                      />
                                    </div>
                                  </TableCell>
                                </TableRow>
                              )
                            )}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </Collapse>
                  </TableCell>
                </TableRow>
              </>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <div className='pagination-wrapper-for-agent-history-tab'>
        <PaginationComponent
          pageIndex={filter?.pageIndex || 0}
          pageSize={filter?.pageSize || 25}
          totalCount={historyData?.totalCount || 0}
          onPageIndexChanged={onPageIndexChanged}
          onPageSizeChanged={onPageSizeChanged}
        />
      </div>
    </div>
  );
}
